import { render } from "./CompanyDetailsPage.vue?vue&type=template&id=e1b6eccc"
import script from "./CompanyDetailsPage.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__